const UICollageSection = () => {
  return (
    <section className="my-20 w-full space-y-10 overflow-x-hidden" data-cy="ui-collage-section">
      <div className="flex translate-x-10 scale-x-110 flex-row gap-10">
        <div className="h-60 w-full rounded-r-2xl bg-slate-700" />
        <div className="h-60 w-full rounded-2xl bg-slate-700" />
        <div className="h-60 w-full rounded-l-2xl bg-slate-700" />
      </div>
      <div className="flex -translate-x-10 scale-x-110 flex-row gap-10">
        <div className="h-60 w-full rounded-r-2xl bg-slate-700" />
        <div className="h-60 w-full rounded-2xl bg-slate-700" />
        <div className="h-60 w-full rounded-l-2xl bg-slate-700" />
      </div>
    </section>
  );
};

export default UICollageSection;
